import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Content, FormDescription, Header } from '../LoginForm/styles';

import './style.css';

class PaymentKioskConnectionWarning extends Component {
  render() {
    return (
      <div className="payment-kiosk-connection-warning-overlay">
        <div className="payment-kiosk-connection-warning-wrapper">
          <Content compact>
            <Header>
              <span>Waiting for connection…</span>
            </Header>
            <FormDescription>
              Please wait for connection to be restored
            </FormDescription>
          </Content>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentKioskConnectionWarning);



// WEBPACK FOOTER //
// ./src/components/PaymentKioskConnectionWarning/PaymentKioskConnectionWarning.jsx